module.exports = __webpack_public_path__ + "img/turkiye-is-bankasi-tilt-machine-01.8031d823.jpg";